import React from 'react'
import DescriptionSkill from '../../descriptionSkill/descriptionSkill'

export default function ComputerSkillDescription({ComputerSkilltData}) {
  return (
    <DescriptionSkill textDesscription={'มี'} data={ComputerSkilltData} />
  )
}
